import { SwiperOptions } from "swiper/types";

export const paymentsSliderConfig: SwiperOptions = {
    mousewheel: true,
    spaceBetween: 24,
    slidesPerView: "auto",
    freeMode: true,
};
